<template>
  <div :id="content.idHTML" class="row mx-0 w-100" :class="jel_getClassObject(content)">
    <label class="mb-0" for="optionGroupeRadio">{{ content.libGroupeRadio }}</label>
    <GroupeRadio v-model="optionGroupeRadio" class="px-1 w-100" :content="contentRadioGroup" />

    <ListeChoix
      ref="libComboBox"
      v-model="optionComboBox"
      class="mt-0 w-100"
      :content="contentComboBox"
    />
  </div>
</template>

<script>
import GroupeRadio from '@/components/formulaire/base/GroupeRadio.vue';
import ListeChoix from '@/components/formulaire/base/ListeChoix.vue';

export default {
  name: 'RadioComboFiltre',
  components: { GroupeRadio, ListeChoix },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      valeurChoix: {
        comboBox: '',
        groupeRadio: '',
      },
    };
  },
  computed: {
    optionGroupeRadio: {
      get() {
        return this.valeurChoix.groupeRadio;
      },
      set(value) {
        this.valeurChoix.groupeRadio = value;
      },
    },
    optionComboBox: {
      get() {
        return this.valeurChoix.comboBox;
      },
      set(value) {
        this.valeurChoix.comboBox = value;
      },
    },
    contentRadioGroup() {
      return {
        options: this.content.optionsGroupeRadio,
        format: 'boutons',
        choixParLigne: this.content.choixParLigne,
        type: 'texte',
        largeurBouton: 'identique',
      };
    },
    contentComboBox() {
      const listeChoix = [];
      if (this.content.listeComboBox) {
        let i = 0;
        while (this.content.listeComboBox[`listeComboBox${i}`] != null) {
          const uneOption = this.content.listeComboBox[`listeComboBox${i}`];
          if (uneOption.valueComboBox == this.optionGroupeRadio) {
            listeChoix.push(uneOption);
          }
          i++;
        }
      }
      return {
        activerRecherche: this.content.activerRecherche,
        libChoix: this.content.libComboBox,
        placeholderSelection: this.content.placeholderComboBox,
        listeChoix,
        inputNameChoix: this.content.inputNameChoix,
        libListeVide: this.content.libListeVide,
        utiliserModaleMobile: this.content.utiliserModaleMobile,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .customRadio {
  &.radio-general {
    .form-check-label {
      padding: 0.25rem 0.5rem 0.25rem 1rem;
    }
  }
  input[type='radio'] {
    margin-top: 0.35rem;
  }
  label {
    font-weight: normal;
  }
}
</style>
